"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogTitleOverrides = void 0;
var createMuiDialogTitleOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            padding: spacing(7, 12, 4),
        },
    });
};
exports.createMuiDialogTitleOverrides = createMuiDialogTitleOverrides;
//# sourceMappingURL=MuiDialogTitle.js.map